import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Input, Spin, DatePicker, InputNumber, Select } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import moment from 'moment';//日期格式化导包
import trans from './translation';
import Message from '../../component/message/message'; // 提示信息弹窗
import context from '../../public/js/context';

import './cohortModule.css';
const { Option } = Select;

const AssignmentModal = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [assignFileTypeList, setAssignFileTypeList] = useState([]);
    const [assignWeight, setAssignWeight] = useState({});
    const [assignList, setAssignList] = useState([]);
    const [flag, setFlag] = useState("add");
    const turnitinReqInd = Form.useWatch('turnitinReqInd', form);

    useEffect(() => {
        if (props.cohortModel.flag === "edit") {
            initForm(props.cohortModel)
        } else {
            initForm({ activeInd: "Y" })
        }
        searchAssignFileType();
        setFlag(props.cohortModel.flag)
    }, []);

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            assignSeq: model.assignSeq ?? '',
            assignWeight: model.assignWeight ?? "",
            assignName: model.assignName ?? "",
            activeInd: model.activeInd ?? "",
            assignDeadline: model.assignDeadline ? moment(new Date(model.assignDeadline), Config.dateFormat5) : "",
            turnitinReqInd: model.turnitinReqInd ?? "",

            storeStudentPaperInd: model.storeStudentPaperInd ?? '',
            checkStoredPaperInd: model.checkStoredPaperInd ?? "",
            checkInternetInd: model.checkInternetInd ?? "",
            checkJournalsInd: model.checkJournalsInd ?? "",
            excludeBibliographyInd: model.excludeBibliographyInd ?? "",
            excludeQuotedMaterialInd: model.excludeQuotedMaterialInd ?? "",
            excludeSmallMatches: model.excludeSmallMatches ?? "",
        });
    }


    const searchAssignWeight = () => {
        Base.callBackApi("cohortModule/searchAssignWeight", props.cohortModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object;
                let list = [];
                setAssignWeight(model)
                if (Base.isNotEmpty(model.assignment1Weight)) {
                    list.push({ label: 1, value: 1 })
                }
                if (Base.isNotEmpty(model.assignment2Weight)) {
                    list.push({ label: 2, value: 2 })
                }
                if (Base.isNotEmpty(model.assignment3Weight)) {
                    list.push({ label: 3, value: 3 })
                }
                if (Base.isNotEmpty(model.assignment4Weight)) {
                    list.push({ label: 4, value: 4 })
                }
                if (Base.isNotEmpty(model.assignment5Weight)) {
                    list.push({ label: 5, value: 5 })
                }
                if (Base.isNotEmpty(model.assignment6Weight)) {
                    list.push({ label: 6, value: 6 })
                }
                if (Base.isNotEmpty(model.assignment7Weight)) {
                    list.push({ label: 7, value: 7 })
                }
                if (Base.isNotEmpty(model.assignment8Weight)) {
                    list.push({ label: 8, value: 8 })
                }
                if (Base.isNotEmpty(model.assignment9Weight)) {
                    list.push({ label: 9, value: 9 })
                }
                if (Base.isNotEmpty(model.assignment10Weight)) {
                    list.push({ label: 10, value: 10 })
                }
                setAssignList(list)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const turnitinReqIndChange = (e) => {
        if (e === "Y") {
            form.setFieldsValue({
                storeStudentPaperInd: "Y",
                checkStoredPaperInd: "Y",
                checkInternetInd: "Y",
                checkJournalsInd: "Y",
                excludeBibliographyInd: "N",
                excludeQuotedMaterialInd: "N",
            });
        }
    }

    const searchAssignFileType = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "ASSIGN_FILE_TYPE" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setAssignFileTypeList(list);
                searchAssignWeight()
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const validateRange = (value) => {
        if (parseFloat(value) > 99 || parseFloat(value) < 8) {
            return Promise.reject('Only numbers from 8 to 99 can be entered.');
        }
        return Promise.resolve();
    };

    // 生成提示信息
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }
    const save = () => {
        form.submit()
    }

    const onCancel = (flag = false) => {
        props.onClose(flag);
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true)
        let url = "cohortModule/updateAssign"
        values.cohortModuleAssignId = props.cohortModel.cohortModuleAssignId
        values.cohortModuleId = props.cohortModel.cohortModuleId
        if (Base.isEmpty(values.assignDeadline)) {
            values.assignDeadline = null
        }
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                props.onClose(true, values);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false);
        });
    }

    const assignChange = (values) => {
        let label = "assignment" + values + "Weight"
        form.setFieldValue("assignWeight", assignWeight[label])
    }


    return (

        <Modal
            visible={true}//控制弹框是否显示
            title={"Assignment Edit"}//标题
            centered//垂直居中
            destroyOnClose={true}//关闭即销毁？
            closable//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭	
            // width={Config.equipmentInfo.type === 'iPad' ? '65%' : (Config.equipmentInfo.type === 'phone' ? '100%' : '50%')}//弹框宽度
            width={'955px'}
            className='assignmentModal'
            onCancel={() => onCancel(false)}//点击取消触发事件
            footer={[
                <Button key='save' className="sysBtn btnBlue" type="primary" onClick={save} icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>,
                <Button key='cancel' className="sysBtn" onClick={() => onCancel(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
            ]}
        >
            <Spin size="large" spinning={isLoad} tip={trans.dataBeSaving[Config.backLang]}>
                <Message ref={messageRef} />
                <Form form={form} onFinish={onFinish}>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysTitles2 mustFill">Assignment</div>
                            <div className="sysSerchInput">
                                <Form.Item
                                    name="assignSeq"
                                    rules={[
                                        { required: true, message: "Assignment is required." },
                                    ]}
                                >
                                    <Select className='sysSelect' onChange={(e) => { assignChange(e) }} disabled>
                                        <Option value=""></Option>
                                        {assignList.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitles2 mustFill" style={{ width: "200px" }}>Weighting</div>
                            <div className="sysSerchInput">
                                <Form.Item
                                    name="assignWeight"
                                    rules={[
                                        { required: true, message: "Weighting is required." },
                                    ]}
                                >
                                    <InputNumber placeholder="Weighting" className='InputNumberInput' disabled
                                        maxLength={4}
                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className='sysRow'>
                        <div className='sysColMin'>
                            <div className="sysTitles2 mustFill">Assignment Name</div>
                            <div className="sysSerchInput">
                                <Form.Item
                                    name="assignName"
                                    rules={[
                                        { required: true, message: "Assignment Name is required." },
                                    ]}
                                >
                                    <Input type="text" placeholder="Assignment Name" maxLength={50} />
                                </Form.Item>
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitles2" style={{ width: "200px" }}>Assignment Deadline</div>
                            <div className="sysSerchInput">
                                <Form.Item
                                    name="assignDeadline"
                                >
                                    <DatePicker placeholder="Assignment Deadline"
                                        className="parts-numberInput datePickerAllWidth"
                                        allowClear={true}
                                        format={Config.dateFormat5} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysTitles2 mustFill">Status</div>
                            <div className="sysSerchInput">
                                <Form.Item
                                    name="activeInd"
                                    rules={[
                                        { required: true, message: "Status is required" },
                                    ]}
                                >
                                    <Select className='sysSelect'>
                                        <Option value=""></Option>
                                        {context.assignStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                        <div className='sysColMin'>
                            <div className="sysTitles2 mustFill" style={{ width: "200px" }}>Use Turnitin</div>
                            <div className="sysSerchInput">
                                <Form.Item
                                    name="turnitinReqInd"
                                    rules={[
                                        { required: true, message: "Use Turnitin is required." },
                                    ]}
                                >
                                    <Select className='sysSelect' onChange={(e)=>turnitinReqIndChange(e)}>
                                        <Option value=""></Option>
                                        {context.indStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>

                    </div>
                    {
                        turnitinReqInd === "Y" &&
                        <>
                            <div>Turnitin Related</div>
                            <div className='line'></div>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitles2">Store Student Papers</div>
                                    <div className="sysSerchInput">
                                        <Form.Item
                                            name="storeStudentPaperInd"
                                        >
                                            <Select className='sysSelect'>
                                                <Option value=""></Option>
                                                {context.storeStudentPaperMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className='sysColMin'>
                                    <div className="sysTitles2" style={{ width: "200px" }}>Check against stored student papers</div>
                                    <div className="sysSerchInput" >
                                        <Form.Item
                                            name="checkStoredPaperInd"
                                        >
                                            <Select className='sysSelect'>
                                                <Option value=""></Option>
                                                {context.indStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitles2">Check against internet</div>
                                    <div className="sysSerchInput">
                                        <Form.Item
                                            name="checkInternetInd"
                                        >
                                            <Select className='sysSelect'>
                                                <Option value=""></Option>
                                                {context.indStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className='sysColMin'>
                                    <div className="sysTitles2" style={{ width: "200px" }}>Check against journals, periodicals and publication</div>
                                    <div className="sysSerchInput">
                                        <Form.Item
                                            name="checkJournalsInd"
                                        >
                                            <Select className='sysSelect'>
                                                <Option value=""></Option>
                                                {context.indStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitles2">Exclude Bibliography</div>
                                    <div className="sysSerchInput">
                                        <Form.Item
                                            name="excludeBibliographyInd"
                                        >
                                            <Select className='sysSelect'>
                                                <Option value=""></Option>
                                                {context.indStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className='sysColMin'>
                                    <div className="sysTitles2" style={{ width: "200px" }}>Exclude Quoted Material </div>
                                    <div className="sysSerchInput">
                                        <Form.Item
                                            name="excludeQuotedMaterialInd"
                                        >
                                            <Select className='sysSelect'>
                                                <Option value=""></Option>
                                                {context.indStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitles2">Exclude Small Matches </div>
                                    <div className="sysSerchInput">
                                        <Form.Item
                                            name="excludeSmallMatches"
                                            rules={[
                                                {
                                                    required: false,
                                                    validator: (rule, value) => validateRange(value)
                                                },
                                            ]}
                                        >
                                            <InputNumber placeholder="Exclude Small Matches" className='InputNumberInput'
                                                maxLength={2}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </Form>
            </Spin>
        </Modal >

    )

}

AssignmentModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    cohortModel: PropTypes.object.isRequired,
}

export default AssignmentModal;